import { motion } from 'framer-motion';
import { Link, withRouter, Redirect, useHistory, useParams } from 'react-router-dom';
import { backdropTransition, transitionDuration } from '../../../../../Util/PageTransitions';
import arrowBack from "../../../../../assets/arrow-back.svg";
import TextEditor from "../../../../../Util/TextEditor/TextEditor.js";
import { useEffect, useState } from 'react';
import axiosApi from '../../../../../core/interceptor/interceptor';
import { config } from '../../../../../config';
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect';
import { messages } from '../../../../../messages';
import { getType } from '@reduxjs/toolkit';

function AddDocuments(props) {
  const id = useParams().id;

  useEffect(() => {
    if (id) {
      getDocuments(id);
    }
    getTypes();
  }, []);


  const [formData, setFormData] = useState({
    title: '',
    content: '',
    event_document_type_id: 0,
  });

  useEffect(() => {
    handleValidation();
  }, [formData])

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errors, setErrors] = useState([]);
  const [types, setTypes] = useState([]);
  const history = useHistory();
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (handleValidation()) {
      if (id) {
        axiosApi.put(`${config.apiUrl}/documents/${id}`, formData)
          .then((res) => {
            if (res.data.data) {
              history.push('/admin/events/documents/')
            }
          });
      } else {
        axiosApi.post(`${config.apiUrl}/documents/`, formData)
          .then((res) => {
            if (res.data.data) {
              history.push('/admin/events/documents/')
            }
          });
      }
    }
  }

  const handleValidation = () => {
    let flag = true;
    let temp = [];
    if (!formData.event_document_type_id) {
      flag = false;
      temp['event_document_type_id'] = messages.emptyDocType
    }

    if (!formData.title) {
      flag = false;
      temp['title'] = messages.emptyTitle
    }

    if (!formData.content) {
      flag = false;
      temp['content'] = messages.documentContent
    }
    setErrors(temp);
    return flag;
  }


  const getTypes = () => {
    axiosApi.get(`${config.apiUrl}/misc/document-type`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          setTypes(res.data.data);
        }
      })
  }

  const getDocuments = () => {
    axiosApi.get(`${config.apiUrl}/documents/${id}`)
      .then((res) => {
        console.log(res.data.data);
        if (res && res.data && res.data.data) {
          setFormData(res.data.data);
        }
      })
  }
  const formDataChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
  }

  console.log(formData, types);
  return <>
    <motion.div className='CreateEventPageWrapper content-wrapper users-wrapper' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
      <div className="top-blk">
        <div className="heading-wrapper">
          <Link to="/admin/events/documents"><button className="primary-btn back-btn"><img src={arrowBack} alt='' /> Back to Documents</button></Link>
          {id ?
            <h1 className='heading adminCreateEventHeaderText'>Edit Document</h1>
            :
            <h1 className='heading adminCreateEventHeaderText'>Create Document</h1>
          }
        </div>
        <form className="formEvent" onSubmit={handleSubmit}>
          <div className="mul-events-body mul-events-body-padding">
            <div className="mul-form">
              <div className="cs-row">
                <div className="cs-col-4 mob-fluid">
                  <div className="mul-input-field">
                    <label htmlFor="">Title*</label>
                    <input name='title' value={formData?.title} onChange={(e) => formDataChange(e)} type="text" placeholder='Title' />
                    <span className="error">{formSubmitted && errors["title"]}</span>
                  </div>
                </div>
                <div className="cs-col-4 mob-fluid">
                  <div className="mul-input-field">
                    <CustomSelect
                      required={true}
                      data={types}
                      label={'Document Type'}
                      placeholder={formData.event_document_type_id && types.length ? types.find(x => +x.id === +formData.event_document_type_id).name : ''}
                      onSelect={(e) => e && formDataChange({
                        target: {
                          name: 'event_document_type_id',
                          value: e.id
                        }
                      })}
                      selector="name"
                    />
                    <span className="error">{formSubmitted && errors["event_document_type_id"]}</span>
                  </div>
                </div>
                <div className="cs-col-12">
                  <div className="mul-input-field">
                    <label htmlFor="">Content*</label>
                    <TextEditor fullwidth={true} value={formData.content} edit={true} type="sport" name="disclaimer" onChange={(e) => formDataChange({
                      target: {
                        name: 'content',
                        value: e
                      }
                    })} />
                    <span className="error">{formSubmitted && errors["content"]}</span>
                  </div>
                </div>
                <div className="cs-col-12 p-30">
                  <div className="btn-group btn-group-start">
                    <button type="submit" className="btn btn-pri">
                      Save
                    </button>
                    <Link to={'/admin/events/documents'} className="btn btn-sec">Cancel</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </motion.div>
  </>
}

export default withRouter(AddDocuments);